import {ShellFooter} from '@hconnect/uikit/src/lib2'
import React from 'react'
import {useTranslation} from 'react-i18next'

export const PomFooter: React.FC = () => {
  const {t} = useTranslation()
  return <ShellFooter label={t('footer.poweredBy')} copyrightNote={t('footer.copyrightNote')} />
}
